import { render, staticRenderFns } from "./tcustomers.vue?vue&type=template&id=2b1cd970&"
import script from "./tcustomers.vue?vue&type=script&lang=js&"
export * from "./tcustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports